export default __webpack_public_path__ + "c634de4ec7a6b2f49af26490bf63fc75.mp4";